import { FormView } from "../FormView";

export function GuestFeedbackPage() {
  return <FormView formId="guest-feedback" />;
}
